<div class="d-flex flex-column gap-2">
	@if(eventToEdit()?.eventTypeId == sessionEventTypeId){
	<common-message [closeable]="false">
		Please reach out to the program team before making any changes to the event.
	</common-message>
	}
	<table style='width:100%' class='pro-table pro-table-no-header pro-table-with-labels pro-table-without-border'>

		<tr>
			<td>Accelerator </td>
			<td>
				{{eventToEdit()?.accName}}
			</td>
		</tr>
		<tr>
			<td>Language </td>
			<td>
				{{eventToEdit()?.languageId == 1 ? 'English':'Spanish'}}
			</td>
		</tr>

		<tr>
			<td>Event Time </td>
			<td>
				<div class="d-flex flex-row align-items-center gap-2">
					<common-date-time-field [field]="form.startDate()"></common-date-time-field>
					<i class="fa-solid fa-arrow-right"></i>
					<common-date-time-field [field]="form.endDate()"></common-date-time-field>
					<div>{{form.duration()}}</div>
				</div>
			</td>
		</tr>
		@if(eventToEdit()?.eventType?.toolNameLabelKey) {
		<tr>
			<td>Tool Enabled</td>
			<td>
				<div>
					<common-select-field [field]="form.toolEnabledSelection()"></common-select-field>
				</div>
				<div>
					@if(form.toolSelectionValue() == 'custom'){
					<div class="d-flex flex-row align-items-center gap-2 mt-1">
						<common-date-time-field [field]="form.toolStartDate()"></common-date-time-field>
						<i class="fa-solid fa-arrow-right"></i>
						<common-date-time-field [field]="form.toolEndDate()"></common-date-time-field>
						<div>{{form.toolDuration()}}</div>
					</div>
					}
				</div>

			</td>
		</tr>
		}
		<tr>
			<td>Host</td>
			<td>
				<div class="d-flex flex-row align-items-center gap-2">
					<staff-selector-widget [disabled]="!form.eventDialogDataService.canEdit()" [data]="staffData()"
						[userId]="app.data().user.userId" [value]="{personId: form.hostPerson().personId}"
						(valueChange)="form.handleStaffValueChange($event)"></staff-selector-widget>

					<a class='link' (click)="form.openPersonDialog()">{{form.hostPerson().fullName}}</a>
				</div>
			</td>
		</tr>
		<tr>
			<td>Location</td>
			<td>
				<div class="d-flex flex-row align-items-center gap-2">
					<common-select-field [field]="form.venue()"></common-select-field>
					<div>
						@if(form.venueValue() == 'In Person'){
						<venue-button
							[venue]="form.values().venueId ?{ venueId: form.values().venueId!, displayedName: form.values().venueDisplayedName!}: undefined"
							(selection)='onVenueSelection($event)'>
						</venue-button>
						}
					</div>
				</div>
			</td>
		</tr>
		<tr>
			<td>Link</td>
			<td>
				<common-url-field [field]="form.link()"></common-url-field>
			</td>
		</tr>
		<tr>
			<td>Public Notes</td>
			<td>
				<common-text-field [field]="form.publicNotes()"></common-text-field>
			</td>
		</tr>

	</table>



	<common-button-row [center]="true">
		<button #eventFormSaveBtn class="btn btn-primary">Update</button>
		<button class="btn btn-danger" (click)="deleteEvent()">Delete</button>
		<button class="btn btn-standard" (click)="setInitialValuesforEdit()">Revert</button>
	</common-button-row>
</div>